import React, { Component } from 'react';


class Single extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data:[],
      
    };
  }
componentDidMount(){
  this.setState({
    data: this.props.data,
    
  }) 
}

componentWillReceiveProps(nextProps) {
  this.setState({
    data: nextProps.data,
    
  }) 
}

subCard=(questionId,opt,grade,questionType,e)=>{
  console.log(questionId,opt,grade,questionType,e.target,'444444')
  if(opt===e.target.value){
    this.props.subCard(questionId,e.target.value,1,grade,questionType);
  }
  else{
    this.props.subCard(questionId,e.target.value,0,0,questionType);
  }
 
}
imgShow=(e)=>{

  this.props.imgShow(e);
}

  render() {
    // console.log(this.props)
    if(this.state.data&&this.state.data.length>0){
    if(this.props.isDan!=='1'){
     //单选
    return (
      <div>
         <div className="qus_title">
         {/* {this.props.listXX}:{this.props.title} */}
          </div>
          {
            this.state.data.map((val,index)=>{
              return( 
                <div key={index}>
              <div className="single_title" onClick={this.imgShow} >
              {this.props.Skey}.({this.props.listXX}题)  <span dangerouslySetInnerHTML = {{ __html:val.question }}></span>({val.questionGrade}分)
              </div>
              {
              val.answerList.map((value,key)=>{
                if(val.cardList&&val.cardList.length>0){
               
                  return(
              
                    <label className="single_sel" key={key}  >
                          <input type="radio" name={"dan"+val.id}  value={value.answerNum} checked={value.answerNum===val.cardList[0].optChoose} onChange={this.subCard.bind(this,val.id,val.optionTrue,val.questionGrade,val.questionType)} /><i></i><span>{value.answerNum}. {value.answerName}</span>
                      </label>
                         )
                
                }else{
                  return(
                  
                    <label className="single_sel" key={key}  >
                          <input type="radio" name={"dan"+val.id}  value={value.answerNum}  onChange={this.subCard.bind(this,val.id,val.optionTrue,val.questionGrade,val.questionType)} /><i></i><span>{value.answerNum}. {value.answerName}</span>
                      </label>
                        )
                }
                  })
                }
               {
                  this.props.ansShow===true&&this.props.isDid===true?
                  <div className="ans_con">
                  <div className="ans_title">正确答案是 <span className="ans_right">{val.optionTrue}</span></div>
                  <div className='ans_tip'>解析</div>
                  <div className="ans_jx" onClick={this.imgShow}><span dangerouslySetInnerHTML = {{ __html:val.analysis}}></span></div>
                  </div>
                 :
                 <div className="ans_cli"></div>
              }
              
               </div>
              )
            })
          }
          
      </div>
    );
  }else{
    //判断
    return(
      <div>
        <div className="qus_title">
        {/* {this.props.listXX}:{this.props.title} （本大题共 {this.state.data.length} 小题） */}
          </div>
          {
            this.state.data.map((val,index)=>{
              return( 
                <div key={index}>
              <div className="single_title" onClick={this.imgShow} >
              {this.props.Skey}.({this.props.listXX}题)  <span dangerouslySetInnerHTML = {{ __html:val.question }}></span>({val.questionGrade}分)
              </div>
              {
                [1].map((value,key)=>{ 
            if(val.cardList&&val.cardList.length>0){
              return(
                <div key={key}>
                <label className="single_sel">
              <input type="radio" name={"pd"+val.id}  value="0" checked={'0'===val.cardList[0].optChoose} onChange={this.subCard.bind(this,val.id,val.optionTrue,val.questionGrade,val.questionType)} /><i></i><span>正确</span>
          </label>
          <label className="single_sel">
              <input type="radio" name={"pd"+val.id}  value="1" checked={'1'===val.cardList[0].optChoose} onChange={this.subCard.bind(this,val.id,val.optionTrue,val.questionGrade,val.questionType)} /><i></i><span>错误</span>
          </label>
          </div>
              )
                }else{
                  return( 
                  <div key={key}>
                  <label className="single_sel">
                <input type="radio" name={"pd"+val.id}  value="0"  onChange={this.subCard.bind(this,val.id,val.optionTrue,val.questionGrade,val.questionType)} /><i></i><span>正确</span>
            </label>
            <label className="single_sel">
                <input type="radio" name={"pd"+val.id}  value="1"  onChange={this.subCard.bind(this,val.id,val.optionTrue,val.questionGrade,val.questionType)} /><i></i><span>错误</span>
            </label>
            </div>
                  )
                }
              })
              }
                
        
              {
                  this.props.ansShow===true&&this.props.isDid===true?
                <div className="ans_con">
               <div className="ans_title">正确答案是 <span className="ans_right">{val.optionTrue=== '1'?"错误":"正确"}</span></div>
               <div className='ans_tip'>解析</div>
               <div className="ans_jx" onClick={this.imgShow}><span dangerouslySetInnerHTML = {{ __html:val.analysis}}></span></div>
               </div>
                 :
                 <div className="ans_cli"></div>
              }
              
               </div>
              )
            })
          }
      </div>
    )
  }
}else{
  return (<div></div>)
}
}
}
export default Single;
